<template>
  <div class="header-wrap" :style="{left: -scrollLeft+'px'}">
    <h1 title="首页-江西鹰潭农业大数据平台">江西鹰潭农业大数据平台</h1>
    <div>
      <!--<a :href="baseIP+'/yingtan/dist/html/navigation.html'" class="back-home">返回首页</a>-->
      <a href="/yingtan/dist/html/navigation.html" class="back-home">返回首页</a>
    </div>
  </div>
</template>

<script type="text/javascript">
import {baseIP} from '../../src/api/config'
  export default {
    name: 'headers',
    data() {
      return {
        scrollLeft: 0,
        scrollTop: 0,
        baseIP
      }
    },
    mounted() {
      // let self = this
      setTimeout(() => {
        window.addEventListener('scroll', this.handleScrollX)
      },10)
    },
    methods: {
      handleScrollX() {
        this.scrollTop = window.pageYOffset || document.documentElement.scrollTop || document.body.scrollTop
        this.scrollLeft = window.pageXOffset || document.documentElement.scrollLeft || document.body.scrollLeft
        //document.getElementById('headers').style.left = -scrollLeft+ 'px'
      }
    }
  }
</script>

<style lang="scss" scoped>
  @import "../assets/css/lib-variable";
  @import "../assets/css/lib-mixin";

  .header-wrap {
    width: 100%;
    min-width: 1280px;
    height: 80px;
    border-top: 2px #42ffff solid;
    box-sizing: border-box;
    @include linear(#23b4b4, #1ea3bf, 90deg);
    display: flex;
    justify-content: space-between;
    align-items: center;
    position: fixed;
    top: 0;
    left: 0;
    z-index: 1000;
    h1 {
      color: #fff;
      font-size: 24px;
      font-weight: bold;
      padding-left: 20px;
    }
    div {
      padding-right: 20px;
      .back-home {
        color: #fff;
        display: inline-block;
        cursor: pointer;
        width: 80px;
        height: 26px;
        line-height: 24px;
        text-align: center;
        box-sizing: border-box;
        border: 1px #55edfb solid;
        border-radius: 13px;
        background-color: rgba(83, 237, 251, .4);
        @include animate();
        &:hover {
          background-color: rgba(83, 237, 251, .7);
        }
      }
    }

  }
</style>




// WEBPACK FOOTER //
// src/components/header.vue